import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import CarpetForm from "./CarpetForm";
import {deleteCarpetData} from "../../aws/DynamoDB"; // Import the CarpetForm component

export default function CarpetCard({ carpet, admin = false, fetchCarpets=null }) {
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);

    const handleClick = () => {
        navigate(`/carpet/${carpet.id}`, { state: { carpet } });
    };

    const handleEdit = () => {
        setIsEditing(true); // Open CarpetForm modal
    };

    const handleClose = () => {
        setIsEditing(false); // Close CarpetForm modal
    };

    const handleDelete = async () => {
        if (window.confirm(`Möchten Sie den Teppich "${carpet.name}" wirklich löschen?`)) {
            try {
                await deleteCarpetData(carpet);
                // alert(`Teppich "${carpet.name}" wurde gelöscht.`);
                fetchCarpets(1, true);
            } catch (error) {
                console.error("Fehler beim Löschen:", error);
            }
        }
    };


    return (
        <>
            <Card>
                {admin && (
                    <AdminButtons>
                        <Button onClick={handleEdit}>Bearbeiten</Button>
                        <DeleteButton onClick={handleDelete}>Löschen</DeleteButton>
                    </AdminButtons>
                )}
                <ImageWrapper onClick={handleClick}>
                    <img
                        src={carpet.images && carpet.images.length > 0 ? carpet.images[0] : "https://via.placeholder.com/300"}
                        alt={carpet.name}
                    />
                </ImageWrapper>
                <Content onClick={handleClick}>
                    <div>
                        <h3>{carpet.name}</h3>
                    </div>
                    {/*<ShortDescription>{carpet.shortDescription}</ShortDescription>*/}
                    <div>
                        <Div>
                            <p>Maße</p>
                            <strong>{carpet.width}x{carpet.height} cm</strong>
                        </Div>
                        {carpet.model!==""&&
                            <Div>
                                <p>Modell</p>
                                <strong>{carpet.model}</strong>
                            </Div>}
                        <Div>
                            <p>Preis</p>
                            {carpet.priceOnRequest ? (
                                <strong>Auf Anfrage</strong>
                            ) : carpet.acctPrice && carpet.orgPrice && parseFloat(carpet.acctPrice) < parseFloat(carpet.orgPrice) ? (
                                <strong>
                                  <span style={{ textDecoration: 'line-through', color: 'gray', marginRight: '8px' }}>
                                      € {parseFloat(carpet.orgPrice).toFixed(2)}
                                  </span>
                                                                <span style={{ color: 'red', fontWeight: 'bold' }}>
                                      € {parseFloat(carpet.acctPrice).toFixed(2)}
                                  </span>
                                </strong>
                            ) : (
                                <strong>
                                    € {(carpet.acctPrice ? parseFloat(carpet.acctPrice) : parseFloat(carpet.orgPrice || 0)).toFixed(2)}
                                </strong>
                            )}
                        </Div>
                        <Div>
                            <p>Objekt Nr.: <strong>{carpet.id}</strong></p>
                        </Div>
                    </div>
                </Content>
            </Card>
            {/* Open CarpetForm as a modal when editing */}
            {isEditing && <CarpetForm carpet={carpet} onClose={handleClose} fetchCarpets={fetchCarpets} />}
        </>
    );
}

/* Styled Components */
const Card = styled.div`
  background: #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
  position: relative;
  width: 380px; /* Maximum width */
  height: 600px; /* Maximum height */
  

  @media (max-width: 600px) {
    font-size: 12px;
  }
  :hover {
    background: #dcdcdc;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 80%; /* Adjusted for better display */
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #dcdcdc;
    padding: 5px;

  }
  @media (max-width: 600px) {
    //height: 70%; /* Adjusted for better display */
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-size: 18px;
    font-weight: bold;
    padding: 5px 0 0 0;
    @media (max-width: 600px) {
      font-size: 12px;
    }
  }

  p {
    font-size: 16px;
    color: #232323;
  }
  div {
    display: inline-flex;
    margin: 0 7px 0 7px;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  
`;

const ShortDescription = styled.p`
  margin-top: 10px;
  font-size: 16px;
  font-style: italic;
  color: #505050;
`;

const AdminButtons = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;

`;

const Button = styled.button`
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 10px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  @media (max-width: 600px) {
    font-size: 12px;
  }
  :hover {
    background: #0056b3;
  }
`;

const DeleteButton = styled(Button)`
  background: #dc3545;

  :hover {
    background: #b02a37;
  }
`;

